export async function doExpireAnimate(animateDuration = 1000, onExpireAnimationEnd?: () => void) {
  return new Promise<boolean>((resolve) => {
    const timer = setTimeout(() => {
      clearTimeout(timer);
      onExpireAnimationEnd?.();
      resolve(true);
    }, animateDuration);
  });
}
